import type { NextRouter } from 'next/router';

const ACTUAL_SESSION_ROUTES = new Set([
  '/scribe/session/[...id]',
  '/scribe/sessions/[[...id]]',
]);

export function getActualSessionPageId(
  router: Pick<NextRouter, 'isReady' | 'pathname' | 'query'>
): string | undefined {
  if (!router.isReady || !ACTUAL_SESSION_ROUTES.has(router.pathname)) return undefined;

  const routeId = router.query.id;
  if (Array.isArray(routeId)) return routeId[0];
  return typeof routeId === 'string' ? routeId : undefined;
}
